import { Navigate, useLocation } from 'react-router-dom';
import { isAdminUser, isUserLoggedIn } from '../../utils/auth';

function AdminRoute({ children }) {
  const location = useLocation();

  if (!isUserLoggedIn()) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!isAdminUser()) {
    return <Navigate to="/login" state={{ forbidden: true }} replace />;
  }

  return children;
}

export default AdminRoute;
